<template>
  <el-container class="reports-view">
    <el-container class="main-container">
      <el-main
        class="main-content"
        v-loading
      >
        <div class="content-header">
          <img src="@assets/codeScan/code_scan_sj.png" />
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ name: 'ReportsIndex' }">{{ $t('ReportsView.REPORTS') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ projectName }}</el-breadcrumb-item>
          </el-breadcrumb>

          <el-button
            style="margin-left: auto;width: 90px"
            size="small"
            @click="handleBack"
          > <i class="el-icon-back"></i> {{ $t('ReportsView.Back') }}</el-button>

        </div>
        <div class="vulnerability-summary">
          <div class="project-name">{{ projectName }}</div>
          <VulStat :vulStat="vulnerabilities" />
          <el-dropdown
            class="export-dropdown"
            trigger="click"
            placement="bottom"
            @command="handleExport"
          >
            <el-button
              type="primary"
              size="small"
              style="width: 90px"
              class="el-dropdown-link"
              :disabled="!total"
            > {{ $t('ReportsView.Export as') }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu
              slot="dropdown"
              class="fileTypeList"
            >
              <el-dropdown-item command="html">
                <span>
                  {{ $t('ReportsView.HTML') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item command="pdf">
                <span>
                  {{ $t('ReportsView.PDF') }}
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="filterWrapper">
          <div class="filter-container">
            <img
              src="@assets/codeScan/notification-icon-filter.png"
              alt="Filter Icon"
              class="filter-icon"
            />
            <el-form
              :model="searchForm"
              :inline="true"
              :show-message="false"
            >
              <el-form-item :label="$t('ReportsView.Severity')">
                <el-select
                  v-model="searchForm.severity"
                  :placeholder="$t('ReportsView.Select')"
                  :multiple="true"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in SeverityOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('ReportsView.Vulnerability')">
                <el-input
                  size="small"
                  v-model="searchForm.category"
                  :placeholder="$t('ReportsView.Search')"
                  class="filter-input"
                  clearable
                />
              </el-form-item>
              <!-- <el-form-item label="PurchaseStatus">
                <el-select
                  :multiple="true"
                  v-model="searchForm.purchaseStatus"
                  placeholder="Select"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in PurchaseStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item> -->
            </el-form>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >{{ $t('ReportsView.SEARCH') }}</el-button>
          </div>
          <div>
            <el-button
              type="primary"
              size="small"
              style="width: 90px"
              :disabled="selection.length === 0"
              @click="handleShare"
              :loading="shareLoading"
            >{{ $t('ReportsView.SHARE') }}</el-button>

            <el-button
              v-if="isSaas"
              type="primary"
              size="small"
              style="width: 90px"
              :loading="buyLoading"
              @click="handleBatchBuy"
              :disabled="buyDisabled"
            >{{ $t('ReportsView.BUY') }}</el-button>
            <el-button
              v-else
              type="primary"
              size="small"
              style="width: 90px"
              @click="handleBuyToken"
            >{{ $t('ReportsView.BUY') }}</el-button>
          </div>
        </div>
        <el-table
          ref="vulTable"
          :data="vulnerabilityDetails"
          style="width: 100%"
          v-loading="loading"
          row-key="vulId"
          :header-cell-class-name="getHeaderCls"
          @select="handleSelect"
          @select-all="handleSelectAll"
        >
          <el-table-column
            :reserve-selection="true"
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="vulId"
            :label="$t('ReportsView.ID')"
            :formatter="(row, col, vulId) => vulId.slice(0, 8)"
          />
          <el-table-column
            prop="severity"
            :label="$t('ReportsView.Severity')"
          >
            <template slot-scope="scope">
              <severity-tag :severity="scope.row.severity" />
            </template>
          </el-table-column>
          <el-table-column
            prop="category"
            :label="$t('ReportsView.Vulnerability')"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                width="300"
                trigger="hover"
              >
                <el-tag
                  style="cursor: default;max-width: 100%;text-overflow: ellipsis;overflow: hidden;"
                  :type="getVulnerabilityTagType(scope.row.category)"
                  size="small"
                >
                  {{ scope.row.category }}
                </el-tag>
                <div
                  class="tipContent"
                  slot="content"
                >
                  <strong>{{scope.row.category}}</strong>
                  <div style="border-bottom: 2px dashed #ffffff; padding: 5px"></div>
                  <div style="padding: 5px">
                    {{ scope.row.description }}
                  </div>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="description"
            label="Description"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top"
                width="300"
                trigger="hover"
                v-if="scope.row.description"
              >
                <div>
                  <strong>{{scope.row.category}}</strong>
                  <div style="border-bottom: 2px dashed #ffffff; padding: 5px"></div>
                  <div style="padding: 5px">
                    {{ scope.row.description }}
                  </div>
                </div>
                <el-tag
                  slot="reference"
                  :type="getStatusTagType(scope.row.description)"
                  size="small"
                  :class="{ 'black-background': scope.row.description }"
                  @click="viewDescription(scope.row)"
                >
                  VIEW
                </el-tag>
              </el-popover>
              <el-tag
                v-else
                :type="getStatusTagType(scope.row.description)"
                size="small"
                :class="{ 'black-background': scope.row.description === 'VIEW' }"
              > N/A </el-tag>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="exploitability"
            :label="$t('ReportsView.Exploitability')"
          >
            <template>
              <span>{{ $t('ReportsView.POC Confirmed') }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="price"
            :label="$t('ReportsView.Price')"
          >
            <template slot-scope="scope">
              {{scope.row.price ? formatCurrency(scope.row) : $t('ReportsView.N/A')}}
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            :label="$t('ReportsView.Payment')"
          >
            <template slot-scope="scope">
              <el-tag
                size="small"
                type="success"
                v-if="scope.row.purchaseStatus === 'PURCHASED'"
              >{{ $t('ReportsView.PAID') }}</el-tag>
              <el-tag
                v-else
                size="small"
              >{{ $t('ReportsView.WAITING') }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="Details"
            :label="$t('ReportsView.Details')"
            min-width="100"
          >
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.purchaseStatus !== 'PURCHASED'"
                :class="scope.row.purchaseStatus == 'PURCHASED' ? 'pay-view' : 'pay-buy'"
                @click="viewDetails(scope.row)"
              >
                {{ $t('ReportsView.VIEW') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer
          style="height: auto"
          v-if="total"
        >
          <el-pagination
            background
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            layout="sizes, prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </el-footer>
      </el-main>
    </el-container>
    <share-dialog
      v-if="shareVisible"
      :visible="shareVisible"
      :vul-list="selection"
      :task-id="taskId"
      @close="handleShareClose"
    />
  </el-container>
</template>

<script>
import { getTaskDetail, createOrder, cancelOrder, getTaskInfo } from '@/api/base';
import VulStat from '@/components/vul-stat.vue';
import SeverityTag from '@/components/severity-tag.vue';
import { SeverityOptions, PurchaseStatusOptions } from '@/enum';
import { formatCurrency } from '@/utils/currency';
import { exportFile } from '@/utils/download';
import ShareDialog from '@/views/Reports/_components/share.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ReportsView',
  components: {
    VulStat,
    SeverityTag,
    ShareDialog,
  },
  data() {
    return {
      SeverityOptions: Object.freeze(SeverityOptions),
      PurchaseStatusOptions: Object.freeze(PurchaseStatusOptions),
      searchForm: {
        severity: this.$route.query.severity ? [this.$route.query.severity] : [],
        category: '',
        purchaseStatus: [],
      },
      taskId: this.$route.query.taskId,
      buyLoading: false,
      selectedDate: null,
      showDatePicker: false,
      projectName: '',
      selectedFilters: [],
      vulnerabilities: [],
      vulnerabilityDetails: [],
      currentPage: 1,
      pageSize: 10,
      loading: true,
      total: 0,
      selectedIdList: [],
      currOrderId: '',
      cancelLoadingIdList: [],
      pageLoading: null,
      selection: [],
      taskInfo: {},
      shareId: '',
      shareVisible: false,
      shareLoading: false,
    };
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.projectName = newQuery.projectName || '--';
        this.vulnerabilities = newQuery.vulnerabilities ? JSON.parse(newQuery.vulnerabilities) : [];
      },
      deep: true,
    },
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.vulnerabilityDetails.slice(start, end);
    },
    allSelectedDisabled() {
      return this.vulnerabilityDetails.every((item) => item.purchaseStatus === 'PURCHASED');
    },
    buyDisabled() {
      const hasUnpaid = this.selection.some((item) => item.purchaseStatus !== 'PURCHASED');

      return !hasUnpaid;
    },
    ...mapGetters('common', ['isSaas']),
  },
  created() {
    this.projectName = this.$route.query.projectName || '--';
    this.fetchTaskDetail();
    this.handleSearch();
  },
  methods: {
    handleBuyToken() {
      this.$router.push({ name: 'TokenManage' });
    },
    handleExport(type) {
      const { taskId } = this.$route.query;
      const params = {
        type,
      };

      this.pageLoading = this.$loading({
        lock: true,
        text: `${this.$t('ReportsView.exporting reports as')} ${type} ...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.6)',
        customClass: 'page-loading',
      });

      const projectName = this.taskInfo.projectName || '';
      const targetServiceUrl = this.taskInfo.params?.originRequestData?.sandboxTargetServiceUrl || '';
      const domain = targetServiceUrl ? new URL(targetServiceUrl).hostname : '';
      const timestamp = new Date().toISOString().replace(/[-:T]/g, '').slice(0, 12);
      const fileName = [domain, 'vulns-report', projectName, timestamp].filter(Boolean).join('-');

      exportFile(taskId, params, fileName).finally(() => {
        this.pageLoading.close();
      });
    },
    getHeaderCls() {
      const isAllSelected = this.vulnerabilityDetails.every((item) => item.purchaseStatus === 'PURCHASED');
      const defaultCls = ['row-header'];

      if (isAllSelected) {
        return [...defaultCls, 'selected-all-row'].join(' ');
      }

      return defaultCls.join(' ');
    },
    fetchTaskDetail() {
      const { taskId } = this.$route.query;
      getTaskInfo(taskId).then((res) => {
        this.taskInfo = res;
        this.vulnerabilities = res.resultsStat || [];
        this.projectName = res.projectName || '--';
      });
    },
    handleSearch() {
      const filters = [];

      if (this.searchForm.severity.length > 0) {
        filters.push({
          field: 'severity',
          op: 'in',
          value: this.searchForm.severity,
        });
      }

      if (this.searchForm.category) {
        filters.push({
          field: 'category',
          op: 'like',
          value: this.searchForm.category,
        });
      }

      if (this.searchForm.purchaseStatus.length > 0) {
        filters.push({
          field: 'purchaseStatus',
          op: 'in',
          value: this.searchForm.purchaseStatus,
        });
      }

      this.getVulnerabilityDetails(filters);
    },
    selectable(row) {
      return row.purchaseStatus !== 'PURCHASED';
    },
    getVulnerabilityTagType(category) {
      switch (category) {
        case 'criticalCount':
          return 'info';
        case 'highCount':
          return 'danger';
        case 'mediumCount':
          return 'warning';
        case 'lowCount':
          return 'primary';
        case 'Low':
          return 'success';
        default:
          return 'default';
      }
    },
    getStatusTagType(status) {
      switch (status) {
        case 'WAIT':
          return 'info';
        case 'VIEW':
          return 'success';
        default:
          return 'default';
      }
    },
    getSeverityClass(severity) {
      switch (severity) {
        case 'Critical':
          return 'severity-critical';
        case 'High':
          return 'severity-high';
        case 'Medium-High':
          return 'severity-medium-high';
        case 'Medium':
          return 'severity-medium';
        case 'Low':
          return 'severity-low';
        default:
          return 'severity-default';
      }
    },
    getVulnerabilityDetails(filters = []) {
      this.loading = true;
      const { taskId } = this.$route.query;
      const data = {
        page: this.currentPage - 1,
        size: this.pageSize,
        filters,
        sorts: ['severity'],
      };

      getTaskDetail(taskId, data)
        .then((res) => {
          this.vulnerabilityDetails = res.data;
          this.total = res.total;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFilterChange(value) {
      const index = value.indexOf('createBefore');
      if (index !== -1) {
        this.filterIndex = index;
        this.selectedFilters = this.selectedFilters.filter((item) => item !== 'createBefore');
        this.showDatePicker = true; // 显示日期选择器
        this.$nextTick(() => {
          this.$refs.filterSelect.blur(); // 手动关闭下拉框
          if (this.$refs.hiddenDatePicker) {
            this.$refs.hiddenDatePicker.showPicker(); // 手动触发日期选择器
          } else {
            console.error('Cannot find hiddenDatePicker ref');
          }
        });
      }
    },
    handleDateChange(date) {
      this.selectedDate = date;
      this.showDatePicker = false;

      // 检查是否已经存在日期
      const createBeforeIndex = this.selectedFilters.findIndex((item) => !isNaN(Date.parse(item)));
      if (createBeforeIndex !== -1) {
        // 覆盖之前的日期选择
        this.selectedFilters.splice(createBeforeIndex, 1, this.selectedDate);
      } else {
        // 添加新的日期选择
        this.selectedFilters.push(this.selectedDate);
      }

      // 在这里你可以处理用户选择的日期
      console.log(`${this.t('ReportsView.Selected date is:')} ${this.selectedDate}`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleSearch();
    },
    handleCommand(command) {
      console.log(command);
      // 处理导出逻辑
    },
    viewDescription(row) {
      // 查看描述的逻辑
      console.log(row);
    },
    viewDetails(row) {
      if (row.purchaseStatus !== 'PURCHASED') {
        this.createOrder([row.vulId]).then((data) => {
          const { clientSecret, orderId } = data;

          this.$router.push({ name: 'Checkout', query: { clientSecret, orderId } });
        });
      } else {
        // Handle other cases
        this.$router.push({
          name: 'VulnerabilityInformation',
          query: {
            taskId: row.taskId,
            vulId: row.vulId,
            projectName: this.projectName,
          },
        });
      }
    },
    createOrder(vulIdList) {
      return createOrder({ vulIds: vulIdList });
    },
    handleBatchBuy() {
      const vulIdList = this.selection
        .filter((item) => item.purchaseStatus !== 'PURCHASED')
        .map((item) => item.vulId)
        .filter(Boolean);
      const taskId = this.$route.query.taskId;
      this.buyLoading = true;

      let orderIds = this.selection
        .filter((item) => item.purchaseStatus !== 'PURCHASED')
        .map((item) => item.orderId)
        .filter(Boolean);
      orderIds = [...new Set(orderIds)];

      let orderPromise = orderIds.length > 0 ? Promise.all(orderIds.map((orderId) => cancelOrder(orderId))) : Promise.resolve();

      orderPromise
        .then(() => {
          return this.createOrder(vulIdList);
        })
        .then((data) => {
          const { orderId } = data;

          this.$router.push({ name: 'Checkout', query: { orderId, taskId } });
        })
        .catch(() => {
          this.$message.error(this.$t('ReportsView.buyFailed'));
        })
        .finally(() => {
          this.buyLoading = false;
        });
    },
    handleSelect(selection) {
      this.selection = selection;
    },
    handleSelectAll(selection) {
      this.selection = selection;
    },
    formatCurrency(row) {
      const currency = row.currency?.toUpperCase() || 'USD';
      const locale = currency === 'CNY' ? 'zh-CN' : 'en-US';

      return formatCurrency(row.price, { currency, conversionFactor: 100, locale });
    },

    handleBack() {
      this.$router.back();
    },
    handleShare() {
      this.shareVisible = true;
    },
    handleShareClose() {
      this.shareVisible = false;
    },
  },
};
</script>
<style lang="scss">
.fileTypeList {
  width: 100px;

  .el-dropdown-menu__item {
    text-align: center;
    line-height: 2.5em;
  }
}

.el-table th.row-header.el-table__cell > .cell {
  padding-left: 14px;
}

.tipContent {
  word-break: break-word;
}

.page-loading {
  .el-loading-spinner i {
    font-size: 40px;
    color: #fff;
  }

  .el-loading-spinner .el-loading-text {
    font-size: 24px;
    color: #fff;
  }
}
.el-popover {
  background-color: #020202 !important;
  color: #ffffff !important;
}

.el-popper .popper__arrow::after {
  border-top-color: black !important;
}

.reports-view {
  width: 100%;
  display: flex;
  // background-color: #f5f5f5;

  .el-form-item {
    margin-bottom: 0;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    width: calc(100% - 80px);
  }

  .sidebar {
    height: calc(100vh - 85px);
    margin: 50px 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .el-menu {
    background: linear-gradient(to bottom, #e9eef2, #fff);
    height: calc(100vh - 85px);
    border-radius: 10px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #fff;
    margin: 0;
    border-radius: 10px;
    width: 100%;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .main-content {
    flex: 1;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .el-footer {
    display: flex;
    justify-content: right;
    margin-top: 18px;
  }

  .logo {
    width: 150px;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .username {
    margin-right: 10px;
  }

  .user-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .export-dropdown {
    margin-left: auto;
  }

  .content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    background-color: #e1e8ed;
    border-radius: 10px;
    padding: 0px 20px;
    height: 55px;

    img {
      position: relative;
      top: 0;
    }

    h2 {
      font-size: 20px;
    }

    .el-breadcrumb {
      font-size: 17px;
      margin: 0px 15px;
      position: relative;
      top: 2px;
    }
  }

  .new-scan-button,
  .buy-selected-button {
    background-color: #000;
    color: #fff;
    border: 2px solid #000;
    width: 125px;
    height: 35px;
    line-height: 5px;
  }

  .pay-view {
    background-color: #b3f365;
    color: #2b2b2b;
    min-width: 60px;
    height: 24px;
    line-height: 1px;
    padding: 0px 10px;
    font-size: 12px;
  }

  .pay-buy {
    min-width: 60px;
    height: 24px;
    line-height: 1px;
    padding: 0px 10px;
    font-size: 12px;

    &.is-disabled {
      background-color: #e1e1e1 !important;
      color: #fff !important;
      border: none !important;
    }
  }

  .filterWrapper {
    margin: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .filter-container {
    display: flex;
    align-items: center;
    margin: 0;
  }

  .filter-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .filter-select {
    flex: 1;
    margin-right: 10px;
  }

  .selected-row {
    background-color: #000 !important;
    color: #fff;
    border-radius: 10px;
  }

  .bookmark {
    width: 30px;
    height: 30px;
  }

  .el-table th.el-table__cell {
    background-color: #eeeeee;
    color: #000000;
  }

  .selected-row {
    background-color: #000 !important;
    color: #fff;
    border-radius: 10px;
  }

  .black-background {
    background-color: #000 !important;
    color: #fff !important;
    border-radius: 5px;
  }

  .vulnerability-summary {
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    gap: 5px;
    padding: 0 20px 0 13px;

    .project-name {
      margin: 5px 10px;
    }

    .el-tag.el-tag--info {
      background-color: #951d1d;
      border-color: #951d1d;
      color: #fff;
    }
  }

  .el-buy-selected {
    height: 32px;
    margin-left: auto;
  }

  .el-button {
    margin: 0 0;
  }

  .severity-critical {
    color: #951d1d;
    /* 红色 */
  }

  .severity-high {
    color: #ff8c00;
    /* 橙红色 */
  }

  .severity-medium-high {
    color: #ff8c00;
    /* 深橙色 */
  }

  .severity-medium {
    color: #1e90ff;
    /* 道奇蓝色 */
  }

  .severity-low {
    color: #32cd32;
    /* 酸橙绿 */
  }

  .severity-default {
    color: #000000;
    /* 黑色 */
  }
}
</style>
